export enum MeetingIntegrationTypes {
  zoom = 0,
  meet = 1,
}
